<template>
  <div id="PrintQuotation" class="preview-quotation">
    <div class="logo border-no">
      <auth-img
        tag="el-image"
        :src="require('../../assets/logo_leybold_sub.png')"
        fit="contain"
      ></auth-img>
    </div>
    <div class="title">真空设备和组件的污染申明 - 表格 HS2</div>
    <div class="tip">
      <div>
        填写此申明之前请阅读并参照程序
        HS1，本申明只能由经过授权并合格的工作人员填写及签署。<br />如果您在填写此表格时需要帮助，请联系您所在地区的销售或客服。
      </div>
      <div class="reback-number">
        <div class="label">返还授权编号</div>
        <div class="input-content">{{ model.reback_authorize_number }}</div>
      </div>
    </div>
    <div class="form-ul">
      <div class="block">1. 设备</div>
      <div class="device-container">
        <div class="device-base">
          <div class="form-li">
            <div class="label">生产商产品名称：</div>
            <div>
              {{ model.device_name }}
            </div>
          </div>
          <div class="form-li">
            <div class="label">生产商零部件号：</div>
            <div>
              {{ model.part_number }}
            </div>
          </div>
          <div class="form-li">
            <div class="label">生产商序列号：</div>
            <div>
              {{ model.serial_number }}
            </div>
          </div>
        </div>
        <div class="device-other">
          <p class="">如果适用：</p>
          <div class="form-li">
            <div class="label">工具识别码：</div>
            <div>
              {{ model.tool_identify_code }}
            </div>
          </div>
          <div class="form-li">
            <div class="label">工具制造商/OEM：</div>
            <div>
              {{ model.tool_maker }}
            </div>
          </div>
          <div class="form-li">
            <div class="label">工具型号：</div>
            <div>
              {{ model.tool_model }}
            </div>
          </div>
          <div class="form-li">
            <div class="label">流程：</div>
            <div>
              {{ model.flow }}
            </div>
          </div>
          <div class="install-date">
            <div class="form-li">
              <div class="label">安装日期：</div>
              <div>{{ model.install_time }}</div>
            </div>
            <div class="form-li ml-10">
              <div class="label">拆装日期：</div>
              <div>{{ model.disassemble_time }}</div>
            </div>
          </div>
          <div class="form-li">
            <div class="label">更换设备的零件号：</div>
            <div>
              {{ model.exchange_part_number }}
            </div>
          </div>
          <div class="form-li">
            <div class="label">更换设备的序列号：</div>
            <div>
              {{ model.exchange_serial_number }}
            </div>
          </div>
        </div>
      </div>

      <div class="block">2. 设备条件</div>
      <div class="device-condition">
        <div class="left">
          <div class="label">
            <div>设备曾被用于：</div>
            <div class="li">
              <span>• 放射性物质</span>
              <span>• 生物试剂/传染源</span>
              <span>• 水银</span>
              <span>• 多氯联苯（PCB）</span>
              <span>• 二恶英</span>
              <span>• 叠氯化钠</span>
            </div>
          </div>
          <el-checkbox
            class="hs2"
            v-model="model.dangerous_device"
            disabled
          ></el-checkbox>
        </div>
        <div class="right">
          <div>
            我们不接受下述任何设备的运输，<br />如果该设备曾被放射性物质、生物试剂/传染源、水银、多氯联苯（PCB）、二恶英或叠氯化钠污染，除非您
          </div>
          <div class="bb">
            <div class="li">
              <span>• 净化设备</span>
              <span>• 提供净化证明</span>
            </div>
            在返还这样的设备前，请务必与我们联系以获得建议。
          </div>
        </div>
      </div>

      <div class="device-condition">
        <div class="left">
          被污染设备
          <el-checkbox
            v-model="model.device_contaminated == 1"
            disabled
            class="hs2"
          ></el-checkbox>
        </div>
        <div class="right">填写第3、4、5栏</div>
      </div>

      <div class="device-condition">
        <div class="left">
          未被污染设备
          <el-checkbox
            v-model="model.device_contaminated == 2"
            disabled
            class="hs2"
          ></el-checkbox>
        </div>
        <div class="right">填写第3、4、5栏</div>
      </div>

      <div class="block">3. 接触设备的物质清单</div>
      <el-table class="device-table" :data="model.devices" border>
        <el-table-column prop="substance" label="物质名称"> </el-table-column>
        <el-table-column prop="chemical_symbol" label="化学符号">
        </el-table-column>
        <el-table-column
          prop="protect_demand"
          label="防护要求（例如使用防护手套等）"
        >
        </el-table-column>
        <el-table-column
          prop="done_option"
          label="在溢出、泄露或曝露后应采取的操作"
        >
        </el-table-column>
      </el-table>

      <div class="block">4. 返还信息</div>
      <div class="reback-info">
        <div class="form-li reback-reason">
          <div class="label">返还原因和故障症状：</div>
          <div>{{ model.reback_reason }}</div>
        </div>
        <div class="form-li run-hour mt-5">
          <div class="label">产品已运行多少小时？</div>
          <div class="input">
            {{ model.run_hour }}
          </div>
        </div>
      </div>

      <div class="block">5. 申明</div>
      <div class="shenming">
        <div class="form-li">
          <div class="label">您的姓名（打印体）：</div>
          <div>
            {{ model.contact_name }}
          </div>
        </div>
        <div class="form-li">
          <div class="label">您的职位（打印体）：</div>
          <div>
            {{ model.contact_position }}
          </div>
        </div>
        <div class="form-li">
          <div class="label">您的单位（打印体）：</div>
          <div>
            {{ model.contact_company }}
          </div>
        </div>
        <div class="form-li"></div>
        <div class="form-li">
          <div class="label">您的地址（打印体）：</div>
          <div>
            {{ model.contact_address }}
          </div>
        </div>
        <div class="form-li"></div>
        <div class="form-li">
          <div class="label">电话号码：</div>
          <div>
            {{ model.contact_mobile }}
          </div>
        </div>
        <div class="form-li">
          <div class="label">设备运送日期：</div>
          <div>{{ model.delivery_time }}</div>
        </div>
        <div class="form-li long">
          <p class="font-12">
            我已经在此申明中提出了合理的问询并提供了准确的信息。我没有隐瞒任何信息，我已遵循程序HS1。
          </p>
        </div>
      </div>
      <div class="sign-container">
        <div class="form-li">
          <div class="label">签名：</div>
          <auth-img
            tag="el-image"
            :src="model.sign"
            style="width: 250px; height: 60px; padding-left: 0"
            fit="contain"
          ></auth-img>
        </div>
        <div class="form-li">
          <div class="label">日期：</div>
          <div class="sign-date">{{ model.sign_time }}</div>
        </div>
      </div>

      <div class="sign-container mt-10">
        <div class="form-li long">
          <p class="font-12">备注：请打印此表格，签名并返回纸质签名表格</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
    },
  },
  data() {
    return {}
  },
  methods: {},
}
</script>

<style scoped>
.preview-quotation {
  margin: 0 auto;
  padding: 0;
  box-sizing: border-box;
  background-color: #fff;
  overflow: hidden;
  font-size: 14px;
}
.logo .el-image {
  border: none;
}
.form-ul {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ccc;
  margin-top: 5px;
}
.form-li {
  display: flex;
  width: 100%;
  line-height: 26px;
  /* font-size: 12px; */
}

.form-li.long {
  width: 100% !important;
}

.form-li.long p {
  margin-bottom: 0;
}

.pd-0 {
  padding: 0 !important;
}

.form-li .label {
  /* color: #adb5be; */
  word-break: keep-all;
}
.block {
  width: 100%;
  background: #c3c3c3;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 15px;
  font-weight: bold;
  font-size: 16px;
  -webkit-print-color-adjust: exact;
}

.title {
  font-size: 18px;
  font-weight: bold;
  line-height: 1;
  margin-top: 15px;
  margin-bottom: 10px;
}

.tip {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
}

.reback-number {
  width: 200px;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  margin-left: 30px;
  font-weight: bold;
}
.input-content {
  border: 1px solid #ccc;
  height: 26px;
  line-height: 26px;
  padding-left: 10px;
}
.device-container {
  display: flex;
  width: 100%;
}

.device-base {
  width: 35%;
  padding: 10px;
  padding-right: 30px;
  border-right: 1px solid #adadad;
}

.device-base .form-li {
  flex-direction: column;
}

.form-li div:last-child {
  border: 1px solid #ccc;
  padding-left: 10px;
  min-height: 28px;
}

.device-other {
  padding: 0 10px;
  width: 65%;
}

.device-other p {
  margin-bottom: 0;
  font-size: 10px;
  margin-bottom: 6px;
}

.device-other .form-li {
  margin-bottom: 4px;
}

.device-other .form-li div:last-child {
  width: 100%;
}
.install-date {
  display: flex;
}

.device-condition {
  display: flex;
  width: 100%;
  border-bottom: 1px solid #adadad;
  /* font-size: 12px; */
}

.device-condition .left {
  width: 45%;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  border-right: 1px solid #adadad;
}

.device-condition .right {
  width: 55%;
  padding: 10px;
}

.device-condition .right .bb {
  margin-top: 28px;
}

.device-condition .left .label {
  display: flex;
  flex-direction: column;
}

.device-condition .li {
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  margin-top: 6px;
}

.device-condition .right .li {
  padding-left: 0;
}

.device {
  color: #333;
}

.reback-info {
  padding: 10px;
  width: 100%;
}

.reback-reason {
  display: flex;
  flex-direction: column;
}

.run-hour .input {
  width: 250px;
}
.shenming {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  justify-content: space-between;
}

.shenming .form-li {
  width: 48%;
  margin-top: 5px;
}

.shenming .form-li .label {
  width: 140px;
  min-width: 140px;
}

.shenming .form-li:nth-child(2n) {
  justify-content: flex-end;
}

.shenming .form-li div:last-child {
  width: 100%;
}
.sign-container {
  display: flex;
  padding: 0 10px;
  width: 100%;
}

.sign-container .form-li {
  margin-right: 20px;
  align-items: center;
  width: auto;
}

.sign-date {
  width: 250px;
  height: 60px;
  line-height: 60px;
}
</style>

<style>
.device-table.el-table thead {
  color: #333;
}

.hs2 .el-checkbox__inner {
  background: #fff !important;
  border-color: #333 !important;
}

.hs2 .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #333 !important;
}

.device-table.el-table.el-table th,
.device-table.el-table.el-table td {
  border-color: #adadad !important;
}

.device-table table {
  table-layout: auto !important;
}

.device-table .el-table__header {
  width: 100% !important;
}
.device-table .el-table__body {
  width: 100% !important;
}
</style>